// extracted by mini-css-extract-plugin
export default {"wrap":"A7oYe","error-icon":"ixAIG"};